export default "__VITE_ASSET__0e9a57d8__"